/**
 * Negates a CSS variable using `calc`
 * https://whatabouthtml.com/how-to-use-negative-value-for-css-variable/
 */
const minus = (variable: string) => `calc(-1 * ${variable})`

export default minus
